export default "__VITE_ASSET__BJbx3X_V__"